/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Header from "../../Layout/Header";
import Footer from "../../Layout/Footer";
import BaseURL from "../../BaseURL/BaseURL";
import axios from "axios";
import "./Editor.css";

const Faq = () => {

    const [data, setData] = useState([]);


    useEffect(() => {
      try {
        var config = {
          method: "get",
          url: `${BaseURL.baseurl}/api/faqs`,
          data: data,
          headers: {
            Accept: "application/json",
            // Authorization: `Bearer ${token}`,
          },
        };
        axios(config)
          .then((response) => {
            console.log(response);
            setData(response?.data?.data);
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {}
    }, []);
  
  return (
    <>
     <Header />
      <section className="mt-5">
        <div className="container">
            <h1 className="text-center my-5 fw-bolder">FAQ</h1>
          {data?.map((e) => {
            return (
                <>
                <div className="ql-editor" dangerouslySetInnerHTML={{ __html: e?.description }} />;
                </>
            )
          })}
        </div>
      </section>
      <Footer />
    </>
  )
}

export default Faq